
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { User } from "@/models/user";
import AppCompanyInfoWrapper from "./CompanyInfoWrapper.vue";

export default Vue.extend({
	data() {
		return {
			selectedRows: [] as Dossier[],
			newDossierModal: false,
			newDossier: new Dossier()
		};
	},
	props: {
		value: {
			type: Object as () => Company,
			required: true
		}
	},
	computed: {
		columns():IDataTableColumn[] {
			return [
				{
					name: "Id",
					property: "id",
					width: "50px"
				},
				{
					name: "Name",
					property: "name",
					width: "200px"
				},
				{
					name: "Users",
					property: "users",
					print(users:User[]):string {
						return users.map(u => u.username).join(", ");
					},
					width: "300px"
				},
			];
		},
		allowededToView():boolean {
			if (this.selectedRows.length == 1) {
				return false;
			}
			return true;
		},
		showDossierInfoToolTip():string{
			return "Show Dossier";
		}
	},
	methods: {
		showDossierInfo() {
			this.$router.push(`/companies/${this.value.id}/dossier/${this.selectedRows[0].id}/info`);
		}
	},
	components: {
		AppCompanyInfoWrapper
	}
});
